<template>
  <!-- 加班修改申请 -->
  <div>
    <Collapse v-model="value2" simple :disabled="prevent" style="border: 0">
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle :titleText="$t('基本信息')" />
        <Form slot="content" :label-width="150" label-position="left" class="titleDistance" :disabled="prevent">
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('申请日期')">
                <Input disabled v-model="formItem.applyDate" />
              </FormItem>
            </Col>
            <!-- <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('申请单号')">
                <Input disabled v-model="formItem.applyNo" />
              </FormItem>
            </Col> -->
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('员工工号')">
                <Input disabled v-model="formItem.empCode" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('姓名')">
                <Input disabled v-model="formItem.userName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('职位')">
                <Input disabled v-model="formItem.positionName" />
              </FormItem>
            </Col>
          </Row>
          <!-- <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('公司')">
                <Input disabled v-model="formItem.orgsname2" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('地区')">
                <Input disabled v-model="formItem.orgsname4" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('部门')">
                <Input disabled v-model="formItem.orgsname5" />
              </FormItem>
            </Col>
          </Row> -->
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle :titleText="$t('加班数据修改')" />
        <Table border :columns="columns2" :data="data2" readonly slot="content" style="margin-top: 20px">
          <template slot-scope="{ row, index }" slot="action">
            <div>
              <span class="ivu-icon ivu-icon-ios-create" style="font-size: 18px; color: rgb(45, 140, 240)" @click="addEduBackground(row, index)"></span>
            </div>
          </template>
          <template slot-scope="{ row, index }" slot="action1">
            <div>
              <Icon style="color: red" type="md-close" @click="delectInternational(row, index)"/>
            </div>
          </template>
        </Table>
        <Button class="applyBtnRight" style="margin-top: 20px; width: 100%" slot="content" @click="selectData">{{ $t("选择加班修改数据") }}</Button>
      </Panel>
    </Collapse>

    <Row class="btnRight">
      <Col>
        <Button class="applyBtnRight" v-if="!isHistory" @click="importCG">{{$t("导入草稿")}}</Button>
        <Button class="applyBtnRight" v-if="!isHistory" @click="saveCG">{{$t("保存草稿")}}</Button>
        <Button class="applyBtnRight" v-if="!isHistory" @click="submitt">{{$t("提交")}}</Button>
        <Button class="applyBtnRight" @click="returnPage">{{$t("返回")}}</Button>
      </Col>
    </Row>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />
    <!-- 审批历史 -->
    <div v-if="isHistory">
      <FormTitle :titleText="$t('审批历史')" style="margin-top: 30px" />
      <Table border :columns="columns1" :data="data1" class="titleDistance">
      </Table>
    </div>
    <Modal v-model="empoloyee" title="选择加班修改数据" width="1600px">
      <Form :model="filter" inline :label-width="50" label-position="left">
        <FormItem :label="$t('员工工号')" :label-width="85">
          <Input
            type="text"
            v-model="filter.serialnumber"
            style="width: 150px"
          ></Input>
        </FormItem>
        <FormItem :label="$t('员工姓名')" :label-width="100">
          <Input
            type="text"
            v-model="filter.userName"
            style="width: 150px"
          ></Input>
        </FormItem>
        <FormItem :label="$t('加班日期')" :label-width="100">
          <Date-picker
            style="width: 100%"
            v-model="filter.att_date"
            type="daterange"
            placement="bottom"
            split-panels
          ></Date-picker>
        </FormItem>
        <Button
          type="primary"
          @click="(total = 0), (pageInfo.pageNum = 1), getp()"
          ><!-- 检索 -->{{$t('Search')}}</Button
        >
      </Form>
      <Table
        ref="myTable"
        :loading="prevent"
        :columns="columns3"
        :data="data3"
        border
      >
        <template slot-scope="{ row, index }" slot="action2">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="select1(row, index)"
            >选择</Button
          >
        </template>
      </Table>
      <div class="pageBox">
        <div></div>
        <Page :total="total" @on-change="pageChange" />
      </div>
      <div slot="footer">
        <Button type="text" @click="handleCancle">取消</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      options1: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      date: new DateUtil(),
      value2: [1, 2],
      formItem: {
        status: "",
        nvchr1: "",
        nvchr2: "",
      },
      empoloyee: false,
      prevent: false,
      isOverdue: false,
      data1: [],
      data2: [],
      data3: [],
      filter: {},
      isHistory: false,
      spinShow: false,
      pageInfo: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  computed: {
    columns1() {
      return [
        {
          title: "审批流名称",
          key: "stepName",
          align: "center",
          width: "280",
        },
        {
          title: "实际审批者",
          key: "userName",
          align: "center",
          width: "280",
        },
        {
          title: "审批时间",
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          },
        },
        {
          title: "审批状态",
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          },
        },
        {
          title: "审批意见",
          key: "message",
          align: "center",
          width: "465",
        },
      ];
    },
    columns2() {
      return [
        {
          title: this.$t("序号"),
          type: "index",
          width: 60,
          align: "center",
          fixed: "left",
        },
        {
          width: 100,
          title: this.$t("员工工号"),
          key: "emp_code",
          fixed: "left",
          align: "center",
        },
        {
          title: this.$t("姓名"),
          width: 100,
          key: "emp_name",
          fixed: "left",
          align: "center",
        },
        // {
        //   title: this.$t("公司"),
        //   key: "gongsi",
        //   width: 70,
        //   align: "center",
        // },
        // {
        //   title: this.$t("地区"),
        //   width: 70,
        //   key: "diqu",
        //   align: "center",
        // },
        // {
        //   title: this.$t("部"),
        //   width: 70,
        //   key: "bu",
        //   align: "center",
        // },
        // {
        //   title: this.$t("课"),
        //   width: 70,
        //   key: "ke",
        //   align: "center",
        // },
        // {
        //   title: this.$t("组"),
        //   width: 70,
        //   key: "zu",
        //   align: "center",
        // },

        {
          title: this.$t("加班日期"),
          width: 110,
          key: "att_date",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.att_date, "YYYY-MM-DD")
            );
          },
        },
        {
          title: this.$t("开始时间"),
          width: 100,
          key: "begin_dt",
          align: "center",
          render: (h, params) => {
            return h("span", this.date.dateVal(params.row.begin_dt, "HH:mm"));
          },
        },
        {
          title: this.$t("结束时间"),
          width: 100,
          key: "end_dt",
          align: "center",
          render: (h, params) => {
            return h("span", this.date.dateVal(params.row.end_dt, "HH:mm"));
          },
        },
        {
          title: this.$t("加班类别"),
          width: 220,
          key: "ot_type",
          align: "center",
        },
        {
          title: this.$t("加班申请单号"),
          key: "order_no",
          align: "center",
        },
        {
          title: this.$t("编辑"),
          key: "edit",
          slot: "action",
          align: "center",
          width: 70,
          fixed: "right",
        },
        {
          title: this.$t("删除"),
          key: "delect",
          slot: "action1",
          align: "center",
          width: 70,
          fixed: "right",
        },
      ];
    },
    columns3() {
      return [
        {
          title: "操作",
          slot: "action2",
          align: "center",
          fixed: "left",
          width: "150",
        },
        {
          width: 100,
          title: "员工工号",
          key: "applySerialnumber",
          fixed: "left",
          align: "center",
        },
        {
          title: "姓名",
          width: 100,
          key: "applyName",
          fixed: "left",
          align: "center",
        },
        // {
        //   title: this.$t("公司"),
        //   key: "gongsi",
        //   width: 70,
        //   align: "center",
        // },
        // {
        //   title: this.$t("地区"),
        //   width: 70,
        //   key: "diqu",
        //   align: "center",
        // },
        // {
        //   title: this.$t("部"),
        //   width: 70,
        //   key: "bu",
        //   align: "center",
        // },
        // {
        //   title: this.$t("课"),
        //   width: 70,
        //   key: "ke",
        //   align: "center",
        // },
        // {
        //   title: this.$t("组"),
        //   width: 70,
        //   key: "zu",
        //   align: "center",
        // },

        {
          title: this.$t("加班日期"),
          width: 110,
          key: "att_date",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.att_date, "YYYY-MM-DD")
            );
          },
        },
        {
          title: this.$t("开始时间"),
          width: 100,
          key: "begin_dt",
          align: "center",
          render: (h, params) => {
            return h("span", this.date.dateVal(params.row.begin_dt, "HH:mm"));
          },
        },
        {
          title: this.$t("结束时间"),
          width: 100,
          key: "end_dt",
          align: "center",
          render: (h, params) => {
            return h("span", this.date.dateVal(params.row.end_dt, "HH:mm"));
          },
        },
        {
          title: this.$t("加班类别"),
          width: 220,
          key: "ot_type",
          align: "center",
        },
        {
          title: this.$t("加班申请单号"),
          key: "order_no",
          align: "center",
        },
      ];
    },
  },
  created() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
  },
  watch: {},
  mounted() {
    // 获取当前登录人信息
    this.getEmpDate();
  },
  methods: {
    //打开草稿列表
    importCG() {
      this.$refs.cgTem.getInternation()
      //草稿type 操作人
      this.$refs.cgTem.popShow('JBXG01',JSON.parse(sessionStorage.getItem('userInfo')).userId)
    },
    //保存草稿
    saveCG() {
      this.$refs.cgPop.getInternation()
      //草稿type 草稿内容
      this.$refs.cgPop.popShow('JBXG01',{formItem: this.formItem,data2: this.data2})
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      var obj = JSON.parse(row.draftContent)
      this.$nextTick(()=>{
        this.formItem = obj.formItem
        this.date2 = obj.data2
      })
    },
    selectData() {
      this.empoloyee = true;
    },
    select1(row) {
      this.data2 = row;
      this.empoloyee = false;
    },
    getEmpDate() {
      let obj = 
        {
          serialnumber: JSON.parse(window.sessionStorage.getItem("userInfo")).serialnumber,
        };
      axios.post("/overTime/selectOverTimeUser", obj).then((res) => {
        if(res){
          this.formItem = res
          this.formItem.applyDate = this.date.dateVal(new Date(), "YYYY-MM-DD")
        }
      })
    },
    pageChange(val) {
      this.pageInfo.pageNum = val;
      this.getp();
    },
    getp() {
      let obj = 
        {
          applySerialnumber: JSON.parse(window.sessionStorage.getItem("userInfo")).serialnumber,
          pageNo : 1,
          pageSize : 10
        };
      axios.post("/OverTimeModifation/selectOverTimeData", obj).then((res) => {
        if(res){
          this.data3 = res.data
        }
      })
    },
    handleCancle() {
      this.empoloyee = false;
    },
    submitt() {
      if(this.data2.length == 0){
        this.$Message.error('请选择加班修改数据！')
        return;
      }
      this.$Modal.confirm({
        title: this.$notice("submission"),
        content: "",
        okText: this.$t("是"),
        cancelText: this.$t("否"),
        onOk: () => {
          this.prevent = true;
          this.handle();
        },
        onCancel: () => {},
      });
    },
    handle() {},
    delectInternational(row, index) {
      this.data2.splice(index, 1);
      // this.ComSelectDataList.splice(index,1)
      // this.ComSelectList.splice(index,1)
    },
    addEduBackground(row, index) {
      //   this.showSelOriginalInformation = true
      //   this.formItem2 = JSON.parse(JSON.stringify(row))
      //   var oldAllHours = (this.formItem2.pshours ? Number(this.formItem2.pshours) : 0 ) + ( this.formItem2.clhours ? Number(this.formItem2.clhours) : 0 )
      //   this.formItem2.new_price_hours ? '' : this.formItem2.new_price_hours = 0
      //   this.formItem2.new_buxiu_hours ? '' : this.formItem2.new_buxiu_hours = oldAllHours
      //   this.formItem2.index = index
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    returnPage() {
      if (this.isHistory) {
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      } else {
        this.$router.push("/4B52EF0102B25075C587E33DA46A7207/A3FFBEBFDB713E27");
      }
    },
  },
};
</script>

<style scoped>
.titleDistance {
  margin: 30px 30px 0 30px;
}
.ivu-input-search {
  cursor: pointer;
  padding: 0 16px !important;
  color: #000 !important;
  background: #f8f8f9 !important;
  border-color: #dcdee2 !important;
  transition: all 0.2s ease-in-out;
  position: relative;
  z-index: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/process/Apply/OvertimeModificationApply.vue